﻿export class NewsletterModel {
    id: number;
    email: string;
    active: boolean;
    dateCreated: Date;
}